import { Counties, County } from 'models/plans-search-types';
import { dataFetcherGet } from 'lib/data-fetcher';

export const getCounties = async (zipcode: string, planType: string): Promise<County[]> => {
  const baseUrl = process.env['PUBLIC_URL'] || '';
  const apiUrl = `${baseUrl}/sc-api/custom/zipcodecounty/getcounties/${zipcode}?planType={${planType}}`;

  try {
    const { data } = await dataFetcherGet<Counties>(apiUrl);
    const { counties } = data;

    return counties || [];
  } catch {
    return [];
  }
};
